import { TYPE_OCCUPATION } from '../../__shared__';
import { DATASOURCE } from '../../__shared__/Occupation/Occupation.constants';

const { ADULT, CHILD } = TYPE_OCCUPATION;

export const getOccupationDataSource = ({ configDataSource = [], occupation = [] } = {}) => {
  const [{ minOccupation = {}, maxOccupation = {} } = {}] = occupation;
  const dataSource = configDataSource.length ? [...configDataSource] : DATASOURCE;

  return dataSource.map((item = {}) => {
    if (item.type === ADULT)
      return {
        ...item,
        ...(maxOccupation.adults !== undefined ? { max: maxOccupation.adults } : undefined),
        ...(minOccupation.adults !== undefined ? { min: minOccupation.adults } : undefined),
      };
    if (item.type === CHILD)
      return {
        ...item,
        ...(maxOccupation.children !== undefined ? { max: maxOccupation.children } : undefined),
        ...(minOccupation.children !== undefined ? { min: minOccupation.children } : undefined),
      };
    return item;
  });
};
